import { supabase } from '../supabaseClient'
import { supabase_url } from '../../env'; 

//Todo: Handle error
let cachedBookmarks;
async function getBookmarks(fetchLatestData) {
    if (fetchLatestData || !cachedBookmarks) {
        let { data: bookmark_with_tags, error } = await supabase
            .from('bookmark_with_tags')
            .select('*')
        cachedBookmarks = bookmark_with_tags;

        populateBookmarkLinks(); 
    }
    return cachedBookmarks;
} 

let cachedBookmarkLinks = new Set();
async function populateBookmarkLinks() {
    if (!cachedBookmarkLinks) {
        await getBookmarks();
    }
    cachedBookmarkLinks = new Set();
    cachedBookmarks.forEach((element) => {
        cachedBookmarkLinks.add(element.link);
    })
}
function getBookmarkLinks() {
    //It's expected that bookmarks are retrieved and cached before the links are retrieved.
    //Hence, returns empty set if cache isn't populated yet. Triggers bookmarks population in parallel.
    if (!cachedBookmarkLinks) {
        populateBookmarkLinks();
    }
    return cachedBookmarkLinks;
}

function extractLink(text, title) {
    text = text.trim();
    //Plain link, shared from Chrome or FF
    if (isValidLink(text)) {
        return text;
    }
    
    //Shared from Materialistic. Format: `<title> - <link>`
    let link = text.substring(text.lastIndexOf('http'));
    let expectedText = title + ' - ' + link;
    if (expectedText == text && isValidLink(link)) {
        return link;
    }
    
    return '';
}

function isValidLink(link) {
    try {
        let urlObject = new URL(link);
        return urlObject.protocol == 'http:' || urlObject.protocol == 'https:';
    } catch (error) {
        return false;
    }
}

async function upsertTags(inputData) {
    const { data: response, error: error } = await supabase
        .from('tag')
        .upsert(inputData, {upsert: true}, {returning: 'representation'});
    let tagIDs = [];
    
    if (response) {
        for (let i = 0; i < response.length; i++) {
            tagIDs.push(response[i].id);
        }
        console.debug('Inserted tags with IDs: ' + tagIDs);
    } else {
        console.warn('Error inserting tags: ');
        console.warn(inputData);
        console.warn(error);
        throw error;
    }
    return tagIDs;
}

async function insertBookmark(inputData) {
    const { data: response, error: error } = await supabase
        .from('bookmark')
        .upsert(inputData, {upsert: true}, {returning: 'representation'});
    let bookmarkID = response[0].id;
    if (response) {
        console.debug('Inserted bookmark with ID: ' + bookmarkID);
    } else {
        console.warn('Error inserting bookmark: ');
        console.warn(error);
        console.warn(inputData);
        throw error;
    }
    return bookmarkID;
}

async function insertBookmarkTagRel(inputData) {
    const { data: response, error: error } = await supabase
        .from('bookmark_tag')
        .upsert(inputData, {upsert: true}, {returning: 'representation'});
    if (response) {
        console.debug('Inserted bookmark_tag: ');
    } else {
        console.warn('Error inserting bookmark_tag: ');
        console.warn(error);
        console.warn(inputData);
        throw error;
    }
}

//https://stackoverflow.com/a/7616484/12415069
function getHash(input) {
    var hash = 0;
    for (var i = 0; i < input.length; i++) {
        var char = input.charCodeAt(i);
        hash = ((hash<<5)-hash)+char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return Math.abs(hash);
}

async function getImageBlobFromUrl(url) {
    const fetchedImageData = await fetch(url);
    const blob = await fetchedImageData.blob();
    return blob;
};

async function deleteBookmark(id) {
    let success = false;
    try {
        const { data: response, error: error } = await supabase
            .from('bookmark')
            .delete()
            .eq('id', id);
        
        if (response) {
            if (response.length == 1) {
                success = true;
                console.debug('Deleted bookmark ID ' + id + 'with link ' + response[0].link);
            } else if (response.length = 0) {
                console.warn('Error deleting Bookmark, ID: ' + id);
                console.warn(error);
                console.warn(response);
            } else {
                console.warn('Multiple bookmarks deleted, ID: ' + id);
                console.warn(error);
                console.warn(response);
            }
        } else {
            console.warn(error);
        }

    } catch (error) {
        console.warn('Unable to delete bookmark with ID ' + id);
        console.warn(error);
    }
    return {success};
}

/**
 * @param data.link
 * @param data.title
 * @param data.description
 * @param data.imgSrc
 * @param data.imgData
 * @param data.tags
 * @param data.isFavourite
 * @param data.isRead
 */
 async function addBookmark(data) {
    let result = {
        success: false,
        msg: 'Error while saving bookmark.'
    };
    try {
        let link = data.link;
        let tags = data.tags;
        
        if(!isValidLink(link)) {
            result.success = false;
            result.msg = 'Invalid link.';
            console.warn('Invalid link, returning. Link: ' + link);
            return result;
        }

        //Upload images, get imageURL
        let filePath = getHash(supabase.auth.user().id + Date.now()) + '-' + Date.now() + '.png';
        console.debug("Filepath: " + filePath);
        let uploadedFilePath, uploadedImgUrl;
        if(data.imgData != null && data.imgData != '') {
            let cacheInDays = 365;
            let cacheInSeconds = (cacheInDays * 86400) + '';
            let file = await getImageBlobFromUrl(data.imgData);
            let { data: imgResponse, error: uploadError } = await supabase.storage
                .from('bookmarks')
                .upload(filePath, file, {
                    cacheControl: cacheInSeconds,
                    contentType: 'image/jpeg',
                    upsert: false
                })

            if (uploadError) {
                console.warn(uploadError);
                result.success = false;
                result.msg = 'Unable to upload image ' + uploadError + '\n Image URL: ' + data.imgSrc;
                return result;
            } else {
                uploadedFilePath = imgResponse.Key;
                console.debug(imgResponse);
                uploadedImgUrl = supabase_url + '/storage/v1/object/public/' + uploadedFilePath;
            }
        }

        console.debug('Image upload URL: ' + uploadedImgUrl);

        const user = supabase.auth.user();

        let tagsData = [];
        let existingTagIds = [];
        let tagIDs = [];

        try {
            //Add only new tags
            for (let tag of tags) {
                if (tag.index) {
                    console.debug('Tag ' + tag.value + ' exists, so not updating');
                    existingTagIds.push(tag.index);
                } else {
                    tagsData.push({'name': tag.value, 'color': tag.color, 'user_id': user.id});
                }
            }
            //Upsert tags
            let newTagIds = await upsertTags(tagsData);
            tagIDs = existingTagIds.concat(newTagIds);
        } catch (error) {
            console.warn(error);
            console.warn(tagsData);
            result.success = false;
            result.msg = 'Unable to add tags: ' + error + '\n Tags data: ' + tagsData;
            return result;
        }

        //Insert bookmark
        let bookmarkData = {
            user_id: user.id,
            link: link,
            title: data.title,
            description: data.description,
            imageurl: uploadedImgUrl,
            isfavourite: false,
            isread: true
        };

        let bookmarkID;
        try {
            bookmarkID = await insertBookmark(bookmarkData);
        } catch (error) {
            console.warn(error);
            result.success = false;
            result.msg = 'Unable to add bookmark: ' + error + '\n Bookmarks data: ' + bookmarkData;
            return result;
        }

        //Insert bookmarkTagRels
        try {
            let bookmarkTagRelsData = [];
            for (let i = 0; i < tagIDs.length; i++) {
                bookmarkTagRelsData.push({'user_id': user.id, 'bookmark_id': bookmarkID, 'tag_id': tagIDs[i]});
            }
            await insertBookmarkTagRel(bookmarkTagRelsData);
            console.debug('Added bookmark rels');
        } catch (error) {
            console.warn(error);
            result.success = false;
            result.msg = 'Unable to add bookmark-tag rels: ' + error + '\n Rels data: ' + bookmarkTagRelsData;
            return result;
        }

        result.success = true;
    } catch (err) {
        result.success = false;
        result.msg = 'Error: ' + err;
    }
    return result;
}


let util = { 
    isValidLink,
    addBookmark,
    getBookmarks,
    getBookmarkLinks,
    extractLink,
    deleteBookmark
};

export { util };